export default __webpack_public_path__ + "static/media/cryptotelegraph_logo.baaf0b9c.svg";